module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_7_3.450ee8cf.jpeg";